import { Can } from '@/components/common';
import { Delete, Edit, RestoreFromTrash } from '@mui/icons-material';
import { IconButton, Stack, Tooltip } from '@mui/material';

type NotesTableActionsProps = {
  id: number;
  deletedAt: string | null;
  // eslint-disable-next-line no-unused-vars
  onEditNote: (id: number) => void;
  // eslint-disable-next-line no-unused-vars
  onDeleteNote: (id: number) => void;
  // eslint-disable-next-line no-unused-vars
  onRestoreNote: (id: number) => void;
  // eslint-disable-next-line no-unused-vars
  onEditNoteMouseEnter: (id: number) => void;
};

export function NotesTableActions({
  id,
  deletedAt,
  onEditNote,
  onDeleteNote,
  onRestoreNote,
  onEditNoteMouseEnter,
}: NotesTableActionsProps) {
  return (
    <Stack direction="row" spacing={1} justifyContent="center">
      <Can permissions={['notes_update']}>
        <Tooltip title="Alterar" disableInteractive>
          <IconButton
            size="small"
            onMouseEnter={() => onEditNoteMouseEnter(id)}
            onClick={() => onEditNote(id)}
          >
            <Edit fontSize="small" />
          </IconButton>
        </Tooltip>
      </Can>
      {deletedAt ? (
        <Can permissions={['notes_restore']}>
          <Tooltip title="Restaurar" disableInteractive>
            <IconButton size="small" onClick={() => onRestoreNote(id)}>
              <RestoreFromTrash fontSize="small" />
            </IconButton>
          </Tooltip>
        </Can>
      ) : (
        <Can permissions={['notes_delete']}>
          <Tooltip title="Excluir" disableInteractive>
            <IconButton size="small" onClick={() => onDeleteNote(id)}>
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
        </Can>
      )}
    </Stack>
  );
}
